import { render } from "./ShippingsAssigned.vue?vue&type=template&id=3b17ee01"
import script from "./ShippingsAssigned.vue?vue&type=script&lang=js"
export * from "./ShippingsAssigned.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__